import { Component, OnInit, ViewChild, EventEmitter, Output, Input, ChangeDetectionStrategy, ViewEncapsulation, ElementRef, HostListener, ChangeDetectorRef } from '@angular/core';
import { SelectItem } from 'primeng/components/common/selectitem';
import { Table } from 'primeng/table';
import { IControlChangeEventArgs } from '@common/formbuilder/IControlChangeEventArgs';
import { IColumnOptions, IDataEndPoint } from '@framework/interfaces/IEntity';
import { ApiService } from '@services/api/api.service';
import { NbToastrService } from '@nebular/theme';
import { IPropertyFilter } from '../../../common/formbuilder/PropertyFilter';
import { IdentityAuthService } from '../../../services/identity-auth/identity-auth.service';
import { DataStateChangeEvent, GridDataResult, GridComponent } from '@progress/kendo-angular-grid';
import { GroupDescriptor, DataResult, process, State, CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';
import { ViewType, FieldType, WhereExpressionType } from '@framework/core/Enums';

@Component({
  selector: 'app-mf-table-v2',
  templateUrl: './mf-table-v2.component.html',
  styleUrls: ['./mf-table-v2.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush, //manaul change detection, huge speed improvement

  encapsulation: ViewEncapsulation.None
})
export class MfTableV2Component implements OnInit {

  private _data: any[] = [];
  private _filterCount: number;
  @Input() public rowHeight: any = 36;
  public gridView: any = { data: [], total: 0 };
  public height = 800;
  @Input() public lazyLoad: boolean = false;
  @Input() public parent: any;
  @Input() public loading: boolean = false;
  @Input() public set data(value) {
    if (this.grouped) {
      if (value && value.data) {
        value.data.forEach(o => {
          if (!o[this.groups[0].field])
            o[this.groups[0].field] = 'Empty';
        })
        this.gridView = process(value.data, { group: this.groups });

      }
    }
    else {
      this.gridView.data = value;
      if (this.gridView.data) {
        if (typeof this.gridView.total == 'undefined' || this.gridView.total < this.gridView.data.length)
          this.gridView.total = this.gridView.data.length
      }
    }
    //if (this.state.skip == 0 && this.gridView.data.length > 0)
    //this.grid.autoFitColumns();

  }
  public get date() {
    return this._data;
  }
  @Input() public set filterCount(value) {
    this._filterCount = value;
    this.gridView.total = value;
  };
  public defaultFilters: CompositeFilterDescriptor = { filters: new Array<FilterDescriptor>(), logic: 'and' };
  public get filterCount() {
    return this._filterCount;
  };
  public groupingSubtotal: any;
  public groups: GroupDescriptor[] = [{ field: 'id' }];
  @Input() public groupingSubtotalCalcField: any;
  @Input() public groupingSubtotalCalcFunc: any;
  @Input() public metadataTemplateItems: any;
  @Input() public skip: any = 0;
  @Input() public rows: any = 50;
  @Input() public filter: any = {};
  @Input() public sort: any = {};
  @Input() public lazy: any = true;
  @Input() public scrollable: any = true;
  @Input() public virtualScroll: any = 'virtual';
  @Input() public columnsChangeRequireApiCall: boolean = true;
  @Input() public limitNumCharsEnabled: boolean = true;
  @Input() public limitNumChars: number = 60;
  @Input() public canDelete: boolean = false;
  @Input() public showFilterCol: boolean = true;
  @Input() public staticFilters: Array<IPropertyFilter>;
  @Input() public grouped: boolean = false;
  @Input() public rowGroupMetadata: any;
  private _groupingField: string = 'id';
  @Input() public set groupingField(value) {
    this._groupingField = value;
    this.groups = [{ field: value }];
  }; public get groupingField() {
    return this._groupingField;
  };
  @Input() public expandedRowKeys: any = {};
  @Input() public autoSizeColumns: boolean = true;
  @Input() public rowGroupMetadataActions: any;
  @Input() public grandTotal: any;
  private _parentInstance: any;
  @Input() public set parentInstance(val) {
    this._parentInstance = val;

  }
  public get parentInstance() {
    return this._parentInstance;
  }


  @Input() public formReadOnly: boolean;
  public _mySelection: any[] = []
  public set mySelection(value) {
    this._mySelection = value;
    if (value && value.length > 0 && this.gridView.data) {
      var filteredItems = this.gridView.data.filter(o => o.id == value[0]);
      this.selectedItem = filteredItems[0];
      // this.mySelection = [];
    }
  }
  public get mySelection() {
    return this._mySelection;
  }
  @Input() public set selectedColumns(value) {
    this._selectedColumns = value;
    this.reloadTable();
    this.selectedVisibleColumns = this.selectedColumns.filter(o => typeof (o.visible) == 'undefined' || o.visible);
  }
  @Input() public set selectedmetadataTemplateItems(value) {
    this._selectedmetadataTemplateItems = value;
    this.selectedmetadataTemplateItemsChange.emit(value);
  }
  @Input() public set selectedItem(value) {
    this._selectedItem = value;
    this.selectedItemChange.emit(value);
  }

  @Output() public onLoadItems: EventEmitter<any> = new EventEmitter();
  @Output() public selectedmetadataTemplateItemsChange = new EventEmitter();
  @Output() public selectedItemChange = new EventEmitter();
  @Output() public staticFiltersChange = new EventEmitter();
  @Output() public onDeleteItem = new EventEmitter();
  @Output() public onPageEvent = new EventEmitter();
  @Output() public onSortEvent = new EventEmitter();
  public onSelectedKeysChange(evt) {
    if (evt && evt.length > 0 && this.gridView.data) {
      var filteredItems = new Array();
      if (this.grouped) {
        var items = this.gridView.data.map(o => {
          return o.items
        }).reduce(function (a, b) { return a.concat(b); })
        filteredItems = items.filter(o => o.id == evt[0]);
      }
      else filteredItems = this.gridView.data.filter(o => o.id == evt[0]);
      this.selectedItem = filteredItems[0];
      this.mySelection = [];
    }
  }
  public state: State = {
    skip: 0,
    take: this.rows,
    filter: this.defaultFilters
  };




  @ViewChild('dt', { static: true }) dt: Table;
  @ViewChild('test', { static: true }) testDiv: ElementRef<any>;;
  @ViewChild(GridComponent, { static: true })
  public grid: GridComponent;
  public selectedVisibleColumns: any;
  private _selectedmetadataTemplateItems: any[];
  private _selectedItem: any = {};
  private _columns: any[] = [];
  private _selectedColumns: any[];
  public _currentFilterObject: any;
  public showFilters: boolean = true;

  public staticColumns: any[];
  public columns: SelectItem[];
  public filters: any = {};
  public ViewType = ViewType;
  public resizeQueed: any;
  public advancedFilters: any[] = [];
  public constructor(private apiService: ApiService, private messageService: NbToastrService, public authService: IdentityAuthService,
    public cdr?: ChangeDetectorRef) { }

  public ngOnInit() {
    var _th = this;
    //if (this._parentInstance.afterInitObserver)
    //  this._parentInstance.afterInitObserver.subscribe(o => {
    //    debugger;
    //    setTimeout(_ => {
    //      this.height = this._parentInstance.testDivHeight;
    //    }, 1);
    //  })
    this.resize();
    //setTimeout(_ => {
    //  //this.height = this.parentInstance.testDivHeight - 55;
    //  //if (this.height <= 0)
    //  //  this.height = 800;
    //  //this.cdr.detectChanges();
    //}, 1);
    this.loadItems(this.state)
  }

  //@HostListener('window:resize', ['$event.target'])
  //onResize() {
  //  this.resize();
  //  //setTimeout(_ => {
  //  //  this.height = this.parentInstance.testDivHeight - 55;
  //  //  if (this.height <= 0)
  //  //    this.height = 800;
  //  //  this.cdr.detectChanges();
  //  //});
  //}

  public resize() {
    //var self = this;
    //if (!self.resizeQueed) {
    //  self.resizeQueed = true;
    //  setTimeout(() => {
    //    var height = 400;
    //    if (self.testDiv.nativeElement.clientHeight > 0 || self.parentInstance.testDivHeight > 0) {
    //      if (self.testDiv.nativeElement.clientHeight > 0) {
    //        height = self.testDiv.nativeElement.clientHeight;

    //      }
    //      else if (self.parentInstance.testDivHeight > 0)
    //        height = self.parentInstance.testDivHeight - 55;

    //      if (height <= 0)
    //        height = 400;
    //      self.height = height;
    //      self.cdr.detectChanges();
    //      console.log(self.height)
    //    }
    //    self.resizeQueed = null

    //  }, 10);
    //}
  }

  getGroupTotal(items) {
    var val = 0;

    if (this.groupingSubtotalCalcFunc) {
      if (!items)
        return '';

      return this.groupingSubtotalCalcFunc(items);
    }

    if (!items || !this.groupingSubtotalCalcField)
      return '';
    else {
      val = items.map(o => {
        return o[this.groupingSubtotalCalcField]
      }).reduce(function (prev, cur) {
        return prev + cur;
      }, 0);
    }
    return 'R ' + val.toLocaleString();
  }

  @Output() public onControlDataChange = new EventEmitter<IControlChangeEventArgs>();
  public get selectedmetadataTemplateItems() {
    return this._selectedmetadataTemplateItems;
  }
  public get selectedColumns() {
    return this._selectedColumns;
  }

  public get selectedItem() {
    return this._selectedItem;
  }

  public reloadTable(clearFilters?: boolean) {
    if (clearFilters) {
      this.state = {
        skip: 0,
        take: this.rows,
        filter: this.defaultFilters
      };
      this._currentFilterObject = {};
    }
    else {
      this.state.skip = 0;

      this._currentFilterObject = {};
    }
    this.loadItems(this.state)
    //if (this.dt) {
    //  var arr = new Array();

    //  this._currentFilterObject = null;
    //  //if (this.lazyLoad)
    //  this.dt.onLazyLoad.emit(this.dt.createLazyLoadMetadata());
    //}
  }

  public pageChange(event) {
    this.state.skip = event.skip;
    this.state.take = event.take;
    this.loadItems(this.state);
  }
  public loadItems(event) {
    this.state = event;
    if (!this.selectedColumns)
      return;
    let filterArr = new Array();
    if (this.state.filter) {
      this.state.filter.filters.forEach(filt => {
        var key: any = filt;
        var col = null;
        var cols = this._selectedColumns.filter(o => o.field == key.field || o.dbField == key.field);
        if (cols.length > 0)
          col = cols[0];
        if ((<any>filt).operator) {
          if ((<any>filt).operator == 'gte') {
            col.whereExpressionType = WhereExpressionType.GreaterThanOrEqual
          }
          if ((<any>filt).operator == 'lte') {
            col.whereExpressionType = WhereExpressionType.LessThanOrEqual
          }
        }
        var val = key.value;
        if (typeof val === 'object' && col.viewType != ViewType.DateTime) {
          val = JSON.stringify(val)
        }
        if (val != null && val != '')
          filterArr.push({ columnName: col.field, filterValue: val, whereFilterType: col.whereFilterType, whereExpressionType: col.whereExpressionType })
      })
      //for (let key in this.state.filter.filters) {
      //  var col;
      //  var cols = this._selectedColumns.filter(o => o.field == key);
      //  if (cols.length > 0)
      //    col = cols[0];
      //  var val = event.filters[key].value;
      //  if (typeof val === 'object') {
      //    val = JSON.stringify(val)
      //  }
      //  filterArr.push({ columnName: key, filterValue: val, whereFilterType: col.whereFilterType, whereExpressionType: col.whereExpressionType })
      //}
    }
    if (this.staticFilters)
      this.staticFilters.filter(function (o) {
        return o.filterValue != '' && o.filterValue != null
      })
        .forEach(o => {
          filterArr.push({ columnName: o.columnName, filterValue: o.filterValue, whereFilterType: o.whereFilterType });
        });
    let filterObject = {
      StartCount: this.state.skip,
      PageSize: this.state.take,
      Filters: filterArr,
      Sort: null,
      SelectedColumns: !this.selectedColumns ? null : this.selectedColumns.map(({ field }) => field)
    };
    if (this.state.sort && this.state.sort.length > 0) { 
      var key = this.state.sort[0];
      var col = null;
      var field = key.field;
      var cols = this._selectedColumns.filter(o => o.field == key.field || o.dbField == key.field);
      if (cols.length > 0) {
        field = cols[0].dbField;
      }

      filterObject.Sort = { key: field, Type: this.state.sort[0].dir == "asc" ? -1 : 1 };
    }
    if (this._currentFilterObject && this._currentFilterObject == JSON.stringify(filterObject)) {
      return;
    }

    this._currentFilterObject = JSON.stringify(filterObject);
    this.onLoadItems.emit(filterObject);
  }

  //public onSelectedKeysChange(e) {
  //  const len = this.mySelection.length; 

  //  //if (len === 0) {
  //  //  this.selectAllState = 'unchecked';
  //  //} else if (len > 0 && len < this.items.length) {
  //  //  this.selectAllState = 'indeterminate';
  //  //} else {
  //  //  this.selectAllState = 'checked';
  //  //}
  //}

  public dataStateChange(state: DataStateChangeEvent): void {
    this.loadItems(state);
  }

  public limitNumberOfChars(val: string) {
    if (!this.limitNumCharsEnabled)
      return val;
    if (val && val.length > this.limitNumChars)
      return val.substring(0, this.limitNumChars) + "...";
    else return val;
  }

  public controlDataChange(value: IControlChangeEventArgs) {
    this.onControlDataChange.emit(value);
  }

  public toggleShowFilters(event) {
    this.showFilters = !this.showFilters;
    event.stopPropagation();
    if (!this.showFilters)
      this.dt.reset()
  }

  public selectAllChange(col: IColumnOptions, value: boolean) {
    event.stopPropagation();
    if (typeof value != "undefined") {
      if (col.selectAllEndPoints) {
        let endPoint: IDataEndPoint = (col.selectAllEndPoints.insert && value) ? col.selectAllEndPoints.insert : (col.selectAllEndPoints.delete && !value) ? col.selectAllEndPoints.delete : null;
        if (endPoint) {
          let self: MfTableV2Component = this;
          self.apiService.exec({
            endPoint: endPoint,
            context: self,
            success: function (data) {
              self.messageService.success('Successfully saved', 'Action');
              self.data.forEach(item => {
                item[col.field] = value;
              })
            },
            error: function (error) {
              self.loading = false;
              self.messageService.danger('Could not save', 'Action');
            }
          })
        }
      }
    }
  }

  public delete(event, rec) {
    this.onDeleteItem.emit(rec);
  }

  public onPage() {
    this.onPageEvent.emit();
  }

  onSort() {

    this.onSortEvent.emit();
  }


  public filterDataChanged(col) {
    //, col.whereExpressionType
    this.dt.filter(this.filters[col.dbField], col.field, col.filterMatchMode)
  }

  public clearFilters() {
    this.filters = new Array();
    this.dt.reset()
  }

  public getGroupItems(group) {
    var arr = new Array();
    var curIndex = group.index;
    while (curIndex < (group.index + group.size)) {
      arr.push(this.data[curIndex++])
    }
    return arr;
  }

  public isActionHidden(action) {
    if (action.visible)
      return !action.visible(this)
    else return false;
  }


}
